import { createAction, props } from '@ngrx/store';
import { TagModel } from '../../models/tag/tag.model';

export const fetchTagList = createAction('[Tags] Fetch tag list');
export const setTagList = createAction('[Tags] Set tag list', props<{ payload: TagModel[] }>());

export const createTag = createAction('[Tags] Create Tag', props<{ payload: TagModel }>());
export const tagCreated = createAction('[Tags] Tag Created', props<TagModel>());

export const updateTag = createAction('[Tags] Update Tag', props<{ payload: TagModel }>());
export const tagUpdated = createAction('[Tags] Tag Updated', props<TagModel>());

export const deleteTag = createAction(
  '[Tags] Delete Tag',
  props<{ payload: TagModel | TagModel[] }>(),
);
export const tagDeleted = createAction(
  '[Tags] Tag Deleted',
  props<{ payload: TagModel | TagModel[] }>(),
);

export const httpFail = createAction('[Tags] Delete Tag Fail', props<{ payload: string }>());
